const EntityType = {
  SUPPLIER: 1,
  AGENT: 3,
  CUSTOMER: 4,
  GHOST: 5,
  SITE: 6
}
export default EntityType
